import {FileData} from "./FileData";
import {FileHandler} from "./FileHandler";
import {UploadHandler, UploadHandlerCollection} from "./UploadHandler";
import { Store } from "vuex";

const uploaders: UploadHandlerCollection = {};

export function queueFile(uploaderName: string, file: any, data: FileData) {
    getUploader(uploaderName).queueFile(file, data);
}

interface PluploadOptions {
    headers?: Record<string, string>;
    [key: string]: any;
}

export function createUploader(name: string, vuexStore: Store<any>, handlers: FileHandler[], options: PluploadOptions = {}): UploadHandler {
    const uHandler = new UploadHandler(name, vuexStore);
    uHandler.registerHandlers(handlers);
    const defaultSettings: PluploadOptions = {
        browse_button: 'uploader_browse_files_' + name,
        runtimes: 'html5',
        chunk_size: '5mb',
        max_retries: 3,
        multi_selection: false,
        url: '/null',
    };

    const settings = {...defaultSettings, ...options};

    for (const handler of handlers) {
        handler.preInitSetup(plupload);
    }

    const uploader = new plupload.Uploader(settings as plupload_settings);

    uploader.init();

    uploader.bind('Error', (up: plupload.Uploader, error: plupload_error) => {
        const fData = uHandler.fileData[error.file.id];
        if (fData.handler) {
            fData.handler.handleError(up, error);
        }
    });


    uploader.bind('FilesAdded', (up: plupload.Uploader, files: Array<plupload.File>) => {
        for (const i in files) {
            const fData = uHandler.fileData[files[i].id];
            if (fData.handler) {
                fData.handler.handleFilesAdded(up, files[i]);
            }
        }
        up.start();
    });

    uploader.bind('BeforeChunkUpload', (up: plupload.Uploader, file: plupload.File, info: any) => {
        const fData = uHandler.fileData[file.id];
        fData.chunkOffset = info.offset;
        if (fData.handler) {
            fData.handler.handleBeforeChunkUpload(up, file, info);
        }
    });

    uploader.bind('ChunkUploaded', (up: plupload.Uploader, file: plupload.File, info: any) => {
        const fData = uHandler.fileData[file.id];
        fData.chunkOffset = info.offset;
        if (fData.handler) {
            fData.handler.handleChunkUploaded(up, file, info);
        }
    });

    uploader.bind('BeforeUpload', (up: plupload.Uploader, file: plupload.File) => {
        const fData = uHandler.fileData[file.id];
        up.settings.url = fData.upload_url;
        if (fData.handler) {
            try {
                fData.handler.handleBeforeUpload(up, file);
            } catch (e) {
                return false;
            }
        }
    });

    uploader.bind('UploadProgress', (up: plupload.Uploader, file: plupload.File) => {
        const fData = uHandler.fileData[file.id];
        fData.progress = file.percent;
        if (fData.handler) {
            fData.handler.handleUploadProgess(up, file);
        }
    });

    uploader.bind('FileUploaded', (up: plupload.Uploader, file: plupload.File) => {
        const fData = uHandler.fileData[file.id];

        if (fData.handler) {
            fData.handler.handleFileUploaded(up, file);
        }
        uHandler.currentFile = null;
    });

    uHandler.uploader = uploader;

    uploaders[name] = uHandler;

    return uHandler;
}

export function getUploader(name: string): UploadHandler {
    return uploaders[name];
}



